document.addEventListener("DOMContentLoaded", function () {
    const selectors = {
        accordion: ".js-accordion",
        header: ".js-accordion-header",
        description: ".js-accordion-description"
    }

    $(selectors.accordion).accordion({
       heightStyle: 'content',
       collapsible: true,
       header: selectors.header
    });
});